import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { TitularisProvider } from '@titularis/ui';
import 'antd/dist/reset.css';
import { App } from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
      // 'always' impede o React Query de pausar a query silenciosamente quando
      // considera o navegador offline: preferimos tentar e mostrar o erro.
      networkMode: 'always',
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado.');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TitularisProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TitularisProvider>
    </QueryClientProvider>
  </StrictMode>,
);
